import {legacyPermissionsEnabled} from '@netx/core-permissions-next';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';

export const canManageSystemGroups = () => {
	if (legacyPermissionsEnabled())
		return currentUserMeetsUserLevel(UserLevel.DIRECTOR);
	return currentUserIsAdmin();
};
